import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/(home)/consume.tsx");
